import React, { useState, useEffect } from 'react';
import axios from 'axios';
import moonIcons from '../assets/moonIcons'
// <PhaseIcon phase={phase} date={date} />


function PhaseIcon(props) {
  const initialMajorMoonPhaseData = {"apiversion": "", "numphases": 1, "phasedata": [],"year": 2000}
  const [majorMoonPhaseData, setMajorMoonPhaseData] = useState({data:initialMajorMoonPhaseData, isLoading:false, error:null});

  useEffect(() => {
    fetchMajorMoonPhaseData();
 }, []);
  

  // Fetch major moon data 

  const fetchMajorMoonPhaseData = async () => {
      setMajorMoonPhaseData({...majorMoonPhaseData, isLoading: true})

         axios
            .get(`https://aa.usno.navy.mil/api/moon/phases/year?year=${props.currentDate.getFullYear()}`)
            .then((response) => {
              const data = response.data;
              const newArr = []
                data.phasedata.map( obj => {
                  const year = obj.year.toString()
                  const month = obj.month.toString().padStart(2, '0')
                  const day = obj.day.toString().padStart(2, '0')
                  const time = 'T'+obj.time+':00'
                  const objDate = new Date(`${year}-${month}-${day}${time}`)
                  const timeZoneFromDB = 0 //time zone value from database
                  const tzDifference = timeZoneFromDB * 60 + objDate.getTimezoneOffset();
                  //convert the offset to milliseconds, add to targetTime, and make a new Date
                  const offsetTime = new Date(objDate.getTime() - tzDifference * 60 * 1000);
                  obj.year = offsetTime.getFullYear()
                  obj.month = offsetTime.getMonth() + 1
                  obj.day = offsetTime.getDate()
                  obj.time = offsetTime.getHours().toString().padStart(2, '0') + ':' + offsetTime.getMinutes().toString().padStart(2, '0')
                  newArr.push(obj)
                })
                data.phasedata = newArr
                setMajorMoonPhaseData({ data, isLoading: false, error: null })

            })
            .catch((err) => {
                console.log(err.message);
            });          




    try {
      const response = await fetch(`https://aa.usno.navy.mil/api/moon/phases/year?year=${props.currentDate.getFullYear()}`);
      if (!response.ok) {
        throw new Error(`HTTP error! status: ${response.status}`);
      }
      const data = await response.json();
        const newArr = []
          data.phasedata.map( obj => {
            const year = obj.year.toString()
            const month = obj.month.toString().padStart(2, '0')
            const day = obj.day.toString().padStart(2, '0')
            const time = 'T'+obj.time+':00'
            const objDate = new Date(`${year}-${month}-${day}${time}`)
            const timeZoneFromDB = 0 //time zone value from database
            const tzDifference = timeZoneFromDB * 60 + objDate.getTimezoneOffset();
            //convert the offset to milliseconds, add to targetTime, and make a new Date
            const offsetTime = new Date(objDate.getTime() - tzDifference * 60 * 1000);
            obj.year = offsetTime.getFullYear()
            obj.month = offsetTime.getMonth() + 1
            obj.day = offsetTime.getDate()
            obj.time = offsetTime.getHours().toString().padStart(2, '0') + ':' + offsetTime.getMinutes().toString().padStart(2, '0')
            newArr.push(obj)
          })
          data.phasedata = newArr
          setMajorMoonPhaseData({ data, isLoading: false, error: null })


    } catch (error) {
      const errorMessage = error instanceof Error ? error.message : 'Unknown error';
      setMajorMoonPhaseData({ data: null, isLoading: false, error: errorMessage });
    }
  };
 
  
  const getPhaseIcon = (phase, date) => {
    const month = date.getMonth() + 1;
    const day = date.getDate();

     const foundMajorPhase = majorMoonPhaseData?.data.phasedata.find((majorPhase) => majorPhase.month === month && majorPhase.day === day);
     if (foundMajorPhase) {
        if (foundMajorPhase.phase === 'Full Moon') return moonIcons.major_fm
        if (foundMajorPhase.phase === 'Last Quarter') return moonIcons.major_lq
        if (foundMajorPhase.phase === 'New Moon') return moonIcons.major_nm
        if (foundMajorPhase.phase === 'First Quarter') return moonIcons.major_fq
      }

    if (phase < 0.0625 || phase >= 0.9375) return moonIcons.nm
    if (phase < 0.1875) return moonIcons.wax_cre
    if (phase < 0.3125) return moonIcons.fq
    if (phase < 0.4375) return moonIcons.wax_gib
    if (phase < 0.5625) return moonIcons.fm
    if (phase < 0.6875) return moonIcons.wan_gib
    if (phase < 0.8125) return moonIcons.lq
    return moonIcons.wan_cre
  };


  return (
    <>
    {!majorMoonPhaseData.isLoading &&
     <img className={`inline w-${props.width} h-${props.height}`} src={getPhaseIcon(props.phase, props.date)} alt='Phase Icon'/>
    }
    </>
  )
}

export default PhaseIcon
